import { EventToUserDto, EventDto } from '../models/dto';

export const isNoSpotsLeft = (
	attendeesLimit: number,
	participantsCount: number,
	includesHost = true,
	includesCoHost = false,
): boolean => getFreeSpotsCount(
	attendeesLimit,
	participantsCount,
	0,
	includesHost,
	includesCoHost,
) <= 0;

export const isExceedsAttendeesLimit = (
	attendeesLimit: number,
	participantsCount: number,
	newSpots = 0,
	includesHost = true,
	includesCoHost = false,
): boolean =>
	getFreeSpotsCount(
		attendeesLimit,
		participantsCount,
		newSpots,
		includesHost,
		includesCoHost,
	) < 0;

export const getFreeSpotsCount = (
	attendeesLimit: number,
	participantsCount: number,
	newSpots = 0,
	includesHost = true,
	includesCoHost = false,
): number =>
	attendeesLimit - getParticipantsCountMinusHost(participantsCount, includesHost, includesCoHost) - newSpots;

export const getRestParticipantsCount = (
	totalParticipantsCount: number,
	displayedParticipants: Array<EventToUserDto> = []
): number => {
	const participantsCount = displayedParticipants.reduce((acc, participant) => acc + participant.quantity, 0);

	return totalParticipantsCount - participantsCount;
};

export const getParticipantsCountMinusHost = (
	participantsCount: number,
	includesHost = true,
	includesCoHost = false
): number => {
	const result = participantsCount - (includesHost ? 1 : 0) - (includesCoHost ? 1 : 0);

	return result > 0 ? result : 0;
};

export const getParticipantsCountBuyers = (eventData?: EventDto): number =>
	eventData?.participantsCount && eventData?.participants
		? eventData.participantsCount - eventData.participants?.reduce((acc, val) => acc + val.quantity - 1, 0)
		: 0;
